import React, { useEffect, useReducer } from "react";
import * as notify from "../../../../shared/notify";

import TaskNav from "../../../task-nav/task-nav";
import Panel from "./components/panel";
import PanelTabs from "../panel-tab";

import { sendSingleAttributeData } from "../../lib/attribute-data";
import { reducer, initialState } from "./reducers";
import { useKeyboardShortcut } from "../../../../shared/hooks/hotkeys";

import "./guaranteed-analysis.scss";

const GuaranteedAnalysisIndex = (props) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const hotkeys = useKeyboardShortcut();

    useEffect(() => {
        if (props.value && props.value.panels.length > 0) {
            dispatch({ type: "SAVE_PANELS", panels: props.value.panels || [], isDirty: false });
        } else {
            addPanel();
        }
    }, []);

    useEffect(() => {
        switch (hotkeys) {
            case "SAVE":
                savePanel();
                break;
            default:
                break;
        }
    }, [hotkeys]);

    const changeTab = (tabIndex) => {
        dispatch({ type: "SET_PANEL_INDEX", selectedPanel: tabIndex });
    };

    const addPanel = () => {
        dispatch({ type: "ADD_PANEL" });
    };

    const removePanel = () => {
        dispatch({ type: "REMOVE_PANEL" });
    };

    const addColumn = () => {
        dispatch({ type: "ADD_COLUMN" });
    };

    const removeColumn = (columnIndex) => {
        dispatch({ type: "REMOVE_COLUMN", columnIndex });
    };

    const updateField = (key, value, column = false) => {
        dispatch({ type: "UPDATE_STATE", key: key, value: value, column: column });
    };

    const updateFieldDeep = (section, key, value, column = false) => {
        dispatch({ type: "UPDATE_DEEP_STATE", section: section, key: key, value: value, column: column });
    };

    const savePanel = async () => {
        try {
            if (!props.skipInternalSave) {
                const response = await sendSingleAttributeData(props.codingWipKey, props.taskId, props.sourcePage, { definition: props.attribute.uuid, type: props.attribute.componentType, value: { panels: state.panels } });

                if (!response) {
                    return false;
                }

                notify.success("Saved");
            }

            props.updateOnChange(props.attribute.uuid, { panels: state.panels }, props.attribute.componentType);
            dispatch({ type: "SET_DIRTY_FLAG", isDirty: false });

            return true;
        } catch (err) {
            notify.error(err);

            return false;
        }
    };

    const closePanel = async () => {
        if (state.isDirty) {
            const confirm = await notify.confirm("You have unsaved data.  Are you sure you want to navigate away? Unsaved data will be lost!");

            if (!confirm) {
                return;
            }
        }

        props.closeModal();
    };

    const panel =
        state.panels.length > 0 ? (
            <Panel
                key={`panel_${state.selectedPanel}`}
                panel={state.panels[state.selectedPanel]}
                selectedIndex={state.selectedPanel}
                removePanel={removePanel}
                updateField={updateField}
                updateFieldDeep={updateFieldDeep}
                addColumn={addColumn}
                removeColumn={removeColumn}
            />
        ) : null;

    return (
        <div className="container">
            <TaskNav>
                <div className="button-group">
                    <button className="button" onClick={closePanel}>
                        Back
                    </button>
                    <h1 className="txt-center">Guaranteed Analysis</h1>
                    <button className="button -primary" onClick={savePanel}>
                        Save
                    </button>
                </div>
            </TaskNav>
            <PanelTabs tabs={state.panels} addTab={addPanel} changeTab={changeTab} selectedIndex={state.selectedPanel} />
            {panel}
        </div>
    );
};

export default GuaranteedAnalysisIndex;
